// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { Box, Button, Text } from '@indeed/ifl-components'
import flexLogoUrl from './logos/indeed-flex-logo-login.svg'

import { LoginSSORedirectProps as Props } from './LoginSSORedirect.types'

import './LoginSSORedirect.css'

// SSO login screen: a "redirecting to Okta" spinner on the happy path; if a sign-in attempt failed
// (e.g. token redeem rejected) we show the error with a retry button.
const LoginSSORedirect = ({ isRetry, feedbackMessage, onRetry, onLoginTrouble }: Props) => (
  <div className="login-container" data-testid="login-container">
    <div className="login">
      <Box as="img" src={flexLogoUrl} className="login-main-logo" />

      <div>
        <Text variant="contrast" sx={{ fontWeight: 'bold' }} level={3}>
          {isRetry ? 'Single sign-on didn’t complete' : 'Signing you in with single sign-on (SSO)…'}
        </Text>
        <Box sx={{ marginTop: '25px', marginBottom: '40px' }}>
          {isRetry ? (
            <Button variant="primary" size="md" type="button" onClick={onRetry}>
              Log in with SSO
            </Button>
          ) : (
            <Button variant="primary" size="md" type="button" loading disabled>
              Redirecting…
            </Button>
          )}
        </Box>
        {feedbackMessage && (
          <p className="feedback-message">
            {`${feedbackMessage} please raise an IT support ticket on `}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://syftapp.slack.com/archives/C01G7U6HWBU"
            >
              slack.
            </a>
          </p>
        )}
      </div>
      <div className="login-trouble-section">
        <div>
          <Button variant="destructiveText" onClick={onLoginTrouble}>
            Having trouble logging in?
          </Button>
        </div>
      </div>
    </div>
  </div>
)

export default LoginSSORedirect
